module.exports = __webpack_public_path__ + "static/media/Inter-LightItalic.df29c534.woff2";